import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue } from "../../assets/helpers";
import BuilderIcon from "../../assets/images/profile_logo.jpg";
import { FETCH_CLIENTS_EMPLOYEES, CLIENT_DETAILS_BY_USERID_NEW } from "../../constant/Apipath";

function capitalizeFirstLetterFields(obj) {
  if (Array.isArray(obj)) {
    return obj.map(capitalizeFirstLetterFields);
  } else if (obj && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toUpperCase() + key.slice(1),
        capitalizeFirstLetterFields(value)
      ])
    );
  }
  return obj;
}

export const getClientList = (responseClientList) => {
  const modifiedClientList = responseClientList.map((item) => ({
    ...item,
    clientEmployeeId: item.ClientEmployeeId || item.id || item.Id
  }));

  let getClientlist = modifiedClientList?.filter((item) => {
    const status = item?.invitationStatus || item?.InvitationStatus;
    const clientId = item?.clientId || item?.ClientId;
    return status === "Accepted" && clientId !== 0 && item?.ClientEmployeeId !== 0;
  });
  let capitalizedClientList = capitalizeFirstLetterFields(getClientlist);
  return capitalizedClientList;
};

export const remapLoginRes = (loginRes) => {
  if (!loginRes) return null;
  const userInformation = loginRes.userInformation;
  const pictureUrl = loginRes.pictureUrl ?? loginRes.PictureUrl ?? userInformation?.pictureUrl ?? userInformation?.PictureUrl;
  return {
    ...loginRes,
    accessToken: loginRes.accessToken ?? loginRes.AccessToken,
    pictureUrl: pictureUrl,
    userInformation: userInformation ? {
      UserId: userInformation.userId !== undefined ? userInformation.userId : userInformation.UserId,
      Email: userInformation.email !== undefined ? userInformation.email : userInformation.Email,
      FirstName: userInformation.firstName !== undefined ? userInformation.firstName : userInformation.FirstName,
      LastName: userInformation.lastName !== undefined ? userInformation.lastName : userInformation.LastName,
      DateCreated: userInformation.dateCreated !== undefined ? userInformation.dateCreated : userInformation.DateCreated,
      DeviceId: userInformation.deviceId !== undefined ? userInformation.deviceId : userInformation.DeviceId,
      IsPrivateEmail: userInformation.isPrivateEmail !== undefined ? userInformation.isPrivateEmail : userInformation.IsPrivateEmail,
      ChatLanguage: userInformation.chatLanguage !== undefined ? userInformation.chatLanguage : userInformation.ChatLanguage,
      IsFirstTimeLoggedIn: userInformation.isFirstTimeLoggedIn !== undefined ? userInformation.isFirstTimeLoggedIn : userInformation.IsFirstTimeLoggedIn,
      ReferredBy: userInformation.referredBy !== undefined ? userInformation.referredBy : userInformation.ReferredBy,
      ReferredSource: userInformation.referredSource !== undefined ? userInformation.referredSource : userInformation.ReferredSource,
      TradeName: userInformation.tradeName !== undefined ? userInformation.tradeName : userInformation.TradeName,
      LastDateTimeStamp: userInformation.lastDateTimeStamp !== undefined ? userInformation.lastDateTimeStamp : userInformation.LastDateTimeStamp,
      IsOrganization: userInformation.isOrganization !== undefined ? userInformation.isOrganization : userInformation.IsOrganization,
      SignupWith: userInformation.signupWith !== undefined ? userInformation.signupWith : userInformation.SignupWith,
      PictureUrl: pictureUrl,
      LoginWith: userInformation.loginWith !== undefined ? userInformation.loginWith : userInformation.LoginWith,
      ClientsList: userInformation.clientsList !== undefined ? userInformation.clientsList : userInformation.ClientsList,
      PendingInvitations: userInformation.pendingInvitations !== undefined ? userInformation.pendingInvitations : userInformation.PendingInvitations,
    } : undefined
  };
};

// Revised to return data logic for handling in Login component
export const getUserinformation = async (rawLoginRes, deviceId) => {
  const loginRes = remapLoginRes(rawLoginRes);
  if (loginRes) {
    let responseClientList = [];
    let pendingInvitations = [];
    try {
      const detailPayload = {
        UserId: Number(loginRes?.userInformation?.UserId),
        UserEmail: loginRes?.userInformation?.Email
      };
      const detailRes = await Postrequestcall(
        CLIENT_DETAILS_BY_USERID_NEW,
        detailPayload,
        loginRes?.accessToken
      );
      // Based on user image, Data contains ClientsList
      responseClientList = detailRes?.data?.Data?.ClientsList || [];
      pendingInvitations =
        detailRes?.data?.Data?.ClientInvitation || detailRes?.data?.Data?.ClientInvitations || [];
    } catch (error) {
      console.log("CLIENT_DETAILS_BY_USERID_NEW Error:", error);
    }

    const capitalizedClientList = getClientList(responseClientList);
    let getObj = {
      ...loginRes,
      userInformation: {
        ...loginRes.userInformation,
        TradeName: loginRes?.userInformation?.TradeName || "",
        ClientsList: capitalizedClientList,
        PendingInvitations: pendingInvitations,
        DeviceID: deviceId
      }
    };

    // Return the object so Login.jsx can handle the modal flow
    return getObj;
  }
  return null;
};
